// extracted by mini-css-extract-plugin
export default {"header":"header__VhFXJ","content":"content__kIsDe","title":"title__2CPQl"};